import { render, staticRenderFns } from "./TournamentBrandingManagement.vue?vue&type=template&id=1e6fe924&"
import script from "./TournamentBrandingManagement.vue?vue&type=script&lang=js&"
export * from "./TournamentBrandingManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports